<template>
  <PlatformDetailPage type="growth" />
</template>

<script>
import PlatformDetailPage from '../components/reference/PlatformDetailPage'

export default {
  name: 'IntegrationPage',
  components: { PlatformDetailPage }
}
</script>
